import React from 'react';
import { Card } from '@tcc/crate';
import classNames from 'classnames';

interface CardTooltipProps extends React.ComponentProps<typeof Card> {
  className?: string;
  testId?: string;
}

const CardTooltip: React.FC<CardTooltipProps> = ({ className, ...props }) => {
  const classString = classNames('card-tooltip', className);

  return <Card {...props} className={classString} />;
};

export default CardTooltip;
